<template>
	<div :class="{'has-error': mensagemErro}">
		<label>
			<span v-if="obrigatorio" class="no-print">*</span>
			{{ label }}:
			<i v-if="info != ''" class="fa fa-fw fa-info-circle has-tooltip" v-tooltip="info"></i>
		</label>
		<date-picker
			class="datepicker-input form-control-datepicker"
			value-type="YYYY-MM-DD"
			:format="_formatDate"
			:value="value"
			:disabled="disabled"
			@input="(value) => $emit('input', value)"
			:disabled-date="disabledDate"
		></date-picker>
		<!-- <input class="form-control" type="date" :value="value" @input="$emit('input', $event.target.value)" /> -->
		<p class="help-block" v-show="mensagemErro">{{ mensagemErro }}</p>
	</div>
</template>

<script>
export default {
	props: {
		label: {
			type: String,
			required: true
		},

		value: {
			type: String,
			required: false,
			default: ''
		},

		mensagemErro: {
			type: String,
			required: false,
			default: ''
		},

		obrigatorio: {
			type: Boolean,
			required: false,
			default: false
		},

		disabledDate: {
			type: Function
		},

		disabled: {
			type: Boolean,
			default: false
		},

		info: {
			type: String,
			default: ''
		}
	}
}
</script>